import { None } from "./types";
import { Scalar, ScalarProvider, ScalarConsumer, scalarValue } from "./Scalar";

export class Or<LeftValueType, RightValueType>
	extends ScalarProvider<LeftValueType | RightValueType>
	implements ScalarConsumer<LeftValueType | None>
{
	private _left_value: LeftValueType | None;
	private _subscriber: ScalarConsumer<LeftValueType | RightValueType> | undefined;

	constructor(
		readonly left_source: ScalarProvider<LeftValueType | None>,
		readonly right_source: Scalar<RightValueType>,
		readonly __origin?: string
	) {
		super();
	}

	get value(): LeftValueType | RightValueType {
		const left_value = this.left_source.value;
		return left_value === None ? scalarValue(this.right_source) : left_value;
	}

	update(left_value: LeftValueType | None) {
		if (this._left_value === None && this.right_source instanceof ScalarProvider) {
			this.right_source.unsubscribe(this._subscriber!);
		}
		this._left_value = left_value;
		if (left_value === None) {
			if (this.right_source instanceof ScalarProvider) {
				this.right_source.subscribe(this._subscriber!);
			} else {
				this._subscriber!.update(this.right_source);
			}
		} else {
			this._subscriber!.update(left_value);
		}
	}

	subscribe(subscriber: ScalarConsumer<LeftValueType | RightValueType>) {
		if (this._subscriber !== undefined) throw new Error("unexpected");
		this._subscriber = subscriber;
		this.left_source.subscribe(this);
		return subscriber;
	}

	unsubscribe(subscriber: ScalarConsumer<LeftValueType | RightValueType>) {
		if ((<any>global)?.alan_strict && this._subscriber !== subscriber) throw new Error("unexpected");
		this._subscriber = undefined;
		this.left_source.unsubscribe(this);
		if (this.right_source instanceof ScalarProvider && this._left_value === None) {
			this.right_source.unsubscribe(subscriber);
		}
	}
}
